module.exports = __webpack_public_path__ + "prod/20261104151832/img/officialAccount.85b10ff1.jpg";